import AdditionalChanges from "./InsightAdgroupandCampaignComponent/AdditionalChanges";
import DailyaverageImpressionShare from "./InsightAdgroupandCampaignComponent/DailyaverageImpressionShare";
import ImpressionShare from "./InsightAdgroupandCampaignComponent/ImpressionShare";
import InsightCards from "./InsightAdgroupandCampaignComponent/InsightCards";
import InsightKeyWordPerformance from "./InsightAdgroupandCampaignComponent/InsightKeyWordPerformance";
import NewSearchTerms from "./InsightAdgroupandCampaignComponent/NewSearchTerms";
import Fab from "@mui/material/Fab";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import SwitchAccountOutlinedIcon from "@mui/icons-material/SwitchAccountOutlined";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import { Typography, Zoom } from "@mui/material";
import { useEffect, useState } from "react";
import { Box, Stack } from "@mui/system";
import ResolveInsightPopup from "./InsightAdgroupandCamapignPopup/ResolveInsightPopup";
import AssignAdgroupPopup from "./InsightAdgroupandCamapignPopup/AssignAdgroupPopup";
import ChangeStatusPopup from "./InsightAdgroupandCamapignPopup/ChangeStatusPopup";
import MoreAdgroupPopup from "./InsightAdgroupandCamapignPopup/MoreAdgroupPopup";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import AutoFixHighOutlinedIcon from "@mui/icons-material/AutoFixHighOutlined";
import { useSelector } from "react-redux";
import {
  selectUserToken,
  setDisplayErrorSnackBar,
} from "../../../../../features/userSlice";
import { useSearchParams } from "react-router-dom";
import { BusinessInsightsEndPointLogic } from "../../../../../logic/AssetManagement/BusinessInsights/BusinessInsightsEndPointLogic";
import store from "../../../../../store";
import { setTaskDetails } from "../../../../../features/businessInsightsSlice";
import {
  format,
  startOfMonth,
  startOfYear,
  subDays,
  subMonths,
} from "date-fns";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";
import CommentsAndFiles from "../../../../Discussion/CommentsAndFiles";

const InsightAdGroup = () => {
  const tableHeadings = {
    keyword: "Keyword",
    match_type: "Match type",
    spend: "Spend",
    cac: "CAC",
    ftd: "FTD",
    qftd: "QFTD",
    imp_share: "IMP Share",
    imp_share_top: "IMP Share Top",
    imp_share_abs_top: "ABS Top",
    avg_qs: "Avg QS",
    cpc: "CPC",
    cvr: "CVR",
    profit: "Profit",
    pv: "PV",
    nrpf: "NRPF",
    clickin: "ClickIn",
    clickouts: "ClickOut",
    Cpc_up: "Cpc up",
    cvr_down: "CVR down",
    imp_share_down: "IMP Share down",
    qs_down: "QS down",
    exact_traffic_mix: "Exact Traffic Mix",
  };

  const NewSearchTemrsTableHeading = {
    search_term: "Search Term",
    kw_name: "Keyword",
    matchtype: "Match Type",
    spend: "Spend",
    CAC: "CAC",
    ftd: "FTD",
    cpc: "CPC",
    clicks: "Clicks",
  };

  // Get Redux selectors first
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const taskDetails = useSelector((state: any) => state.businessInsights.taskDetails);
  const kewordPerformance = useSelector((state: any) => state.businessInsights.keywordPerformance);
  const newSearchTerms = useSelector((state: any) => state.businessInsights.newSearchTerms);
  const impressionShare1 = useSelector((state: any) => state.businessInsights.impressionShare1);
  const impressionShare2 = useSelector((state: any) => state.businessInsights.impressionShare2);
  const dailyAverage = useSelector((state: any) => state.businessInsights.dailyAverage);

  const getDefaultDates = () => {
    const endDate = new Date();
    const startDate = subDays(endDate, 30);
    return {
      startDate: format(startDate, "yyyy-MM-dd"),
      endDate: format(endDate, "yyyy-MM-dd"),
    };
  };

  const calculateDateRange = (timeframe: any, taskDetailsData?: any) => {
    const today = new Date();
    let start, end;

    switch (timeframe) {
      case "insightTimeframe":
        // Use provided taskDetailsData first, then fall back to Redux state
        const startDate = taskDetailsData?.data?.['query_output:start_date']?.value || taskDetails?.data?.['query_output:start_date']?.value;
        const endDate = taskDetailsData?.data?.['query_output:end_date']?.value || taskDetails?.data?.['query_output:end_date']?.value;
        if (startDate && endDate) {
          start = format(new Date(startDate), "yyyy-MM-dd");
          end = format(new Date(endDate), "yyyy-MM-dd");
        } else {
          // Fallback to last 30 days if no valid insight timeframe data
          start = format(subDays(today, 30), "yyyy-MM-dd");
          end = format(today, "yyyy-MM-dd");
        }
        break;
      case "last30":
        start = format(subDays(today, 30), "yyyy-MM-dd");
        end = format(today, "yyyy-MM-dd");
        break;
      case "yesterday":
        start = end = format(subDays(today, 1), "yyyy-MM-dd");
        break;
      case "lastWeek":
        end = format(subDays(today, 2), "yyyy-MM-dd");
        start = format(subDays(today, 9), "yyyy-MM-dd");
        break;
      case "mtd":
        start = format(startOfMonth(today), "yyyy-MM-dd");
        end = format(today, "yyyy-MM-dd");
        break;
      case "lastMonth":
        const lastMonth = subMonths(today, 1);
        start = format(startOfMonth(lastMonth), "yyyy-MM-dd");
        end = format(subDays(startOfMonth(today), 1), "yyyy-MM-dd");
        break;
      case "ytd":
        start = format(startOfYear(today), "yyyy-MM-dd");
        end = format(today, "yyyy-MM-dd");
        break;
      case 'bidChange':
        // Use provided taskDetailsData first, then fall back to Redux state
        const daysCount = taskDetailsData?.data?.['query_output:num_of_days_since_change']?.value || taskDetails?.data?.['query_output:num_of_days_since_change']?.value;
        if (daysCount && !isNaN(Number(daysCount)) && Number(daysCount) > 0) {
          const bidChangeDate = subDays(today, Number(daysCount));
          start = format(bidChangeDate, "yyyy-MM-dd");
          end = format(today, "yyyy-MM-dd")
        } else {
          // Fallback to last 30 days if no valid bid change data
          start = format(subDays(today, 30), "yyyy-MM-dd");
          end = format(today, "yyyy-MM-dd");
        }
        break;
      default: // insightTimeframe (default case)
        const defaultStartDate = taskDetailsData?.data?.['query_output:start_date']?.value || taskDetails?.data?.['query_output:start_date']?.value;
        const defaultEndDate = taskDetailsData?.data?.['query_output:end_date']?.value || taskDetails?.data?.['query_output:end_date']?.value;
        if (defaultStartDate && defaultEndDate) {
          start = format(new Date(defaultStartDate), "yyyy-MM-dd");
          end = format(new Date(defaultEndDate), "yyyy-MM-dd");
        } else {
          start = format(subDays(today, 30), "yyyy-MM-dd");
          end = format(today, "yyyy-MM-dd");
        }
    }
    const result = { startDate: start, endDate: end };
    return result;
  };

  const [open, setOpen] = useState(false);
  const [openResolvePopup, setOpenResolvePopup] = useState(false);
  const [openAssignPopup, setOpenAssignPopup] = useState(false);
  const [openStatusPopup, setOpenStatusPopup] = useState(false);
  const [openMorePopup, setOpenMorePopup] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedTimeframe, setSelectedTimeframe] = useState(searchParams.get('timeFrame') || 'insightTimeframe') as any;
  
  // Initialize dateRange based on the timeframe from URL params
  const initializeDateRange = () => {
    const timeframeFromUrl = searchParams.get('timeFrame') || 'insightTimeframe';
    // For bidChange, return a placeholder until taskDetails is loaded
    if (timeframeFromUrl === 'bidChange') {
      return getDefaultDates(); // Temporary placeholder, will be corrected when taskDetails loads
    }
    return calculateDateRange(timeframeFromUrl);
  };
  
  const [dateRange, setDateRange] = useState(initializeDateRange());
  const [loading, setLoading] = useState(false);
  const taskSharedUid = searchParams.get("taskSharedUid");
  const websiteSharedUid =  taskDetails?.website_shared_uid;
  // Reset state only when component unmounts, not on mount
  useEffect(() => {
    return () => {
      store.dispatch(setTaskDetails([]));  // Reset when component unmounts (navigating away)
    };
  }, []);

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  const ResolvePopupOpen = () => {
    setOpenResolvePopup(true);
  };

  const ResolvePopupClose = () => {
    setOpenResolvePopup(false);
  };

  const AssignPopupOpen = () => {
    setOpenAssignPopup(true);
  };

  const AssignPopupClose = () => {
    setOpenAssignPopup(false);
  };

  const ChangeStatusPopupOpen = () => {
    setOpenStatusPopup(true);
  };

  const ChangeStatusPopupClose = () => {
    setOpenStatusPopup(false);
  };

  const MorePopupOpen = () => {
    setOpenMorePopup(true);
  };

  const MorePopupClose = () => {
    setOpenMorePopup(false);
  };

  // const initialQuery = "5694034018304000"; // This is the initial query ID for Adgroup and Campaign Insights
  const KeywordPerformanceQuery = "5645599001018368"; // This is the query ID for Keyword Performance
  const NewSearchTermsQuery = "5651072089587712"; // This is the query ID for New Search Terms
  const ImpressionShareQuery1 = "5753763457400832"; // This is the query ID for Impression Share
  const ImpressionShareQuery2 = "5688703292801024"; // This is the query ID for Impression Share 2
  const DailyAverageQuery = "5651673292734464"; // This is the query ID for Impression Share 3

  // Initialize timeFrame param and load data
  useEffect(() => {
    if (!searchParams.get("timeFrame")) {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set("timeFrame", "insightTimeframe");
      setSearchParams(newSearchParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Sync dateRange with selectedTimeframe changes (including on mount)
  useEffect(() => {
    const timeframeFromUrl = searchParams.get('timeFrame');
    if (timeframeFromUrl && timeframeFromUrl !== selectedTimeframe) {
      setSelectedTimeframe(timeframeFromUrl);
    }
    if (timeframeFromUrl) {
      // Skip date range calculation for special timeframes if taskDetails is not loaded yet
      if ((timeframeFromUrl === 'bidChange' || timeframeFromUrl === 'insightTimeframe') && (!taskDetails || !taskDetails.data)) {
        return; // Will be calculated in fetchTaskDetails useEffect when data is available
      }
      const newDateRange = calculateDateRange(timeframeFromUrl);
      setDateRange(newDateRange);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, taskDetails]);

  useEffect(() => {
    if (taskSharedUid && selectedTimeframe) {
      const fetchTaskDetails = async () => {
        setLoading(true);
        try {
          if (!taskSharedUid) return;
          const response = await BusinessInsightsEndPointLogic.getTaskDetails(
            oauthTokenHeader,
            taskSharedUid
          );
          if (!response?.data) return;
          if (response?.data) {
            // Recalculate date range after taskDetails is loaded, especially for bidChange
            // Pass the fresh response data to calculateDateRange so it doesn't rely on Redux state
            const currentDateRange = calculateDateRange(selectedTimeframe, response.data);
            setDateRange(currentDateRange);
            
            const websiteUid = response.data?.website_shared_uid;
            const adgroupId = response.data.data['query_output:adgroup_id']?.value;
            if (!taskSharedUid || !websiteUid || !adgroupId ) return;
            await Promise.allSettled([
              BusinessInsightsEndPointLogic.getKeywordsPerformance(oauthTokenHeader, KeywordPerformanceQuery, websiteUid, adgroupId, currentDateRange.startDate, currentDateRange.endDate, "site"),
              BusinessInsightsEndPointLogic.getNewSearchTerms(oauthTokenHeader, NewSearchTermsQuery, websiteUid, adgroupId, currentDateRange.startDate, currentDateRange.endDate, "site"),
              BusinessInsightsEndPointLogic.getImpressionShare1(oauthTokenHeader, ImpressionShareQuery1, websiteUid, adgroupId, currentDateRange.startDate, currentDateRange.endDate, "site"),
              BusinessInsightsEndPointLogic.getImpressionShare2(oauthTokenHeader, ImpressionShareQuery2, websiteUid, adgroupId, currentDateRange.startDate, currentDateRange.endDate, "site"),
              BusinessInsightsEndPointLogic.getDailyAverage(oauthTokenHeader, DailyAverageQuery, websiteUid, adgroupId, currentDateRange.startDate, currentDateRange.endDate, "site")
            ]);
          }
        } catch (error: any) {
          store.dispatch(
            setDisplayErrorSnackBar({
              message:
                error?.parsedText ||
                "Error while fetching data. Please try again later.",
              type: "error",
            })
          );
        } finally {
          setLoading(false);
        }
      };
      fetchTaskDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oauthTokenHeader, taskSharedUid, selectedTimeframe]);

  const handleTimeframeChange = async (_event: any, newValue: any) => {
    const timeframe = newValue?.value;
    if (!timeframe) return;

    setSelectedTimeframe(timeframe);

    // Update URL parameter
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set("timeFrame", timeframe);
    setSearchParams(newSearchParams);

    // Calculate new date range
    const newDateRange = calculateDateRange(timeframe);
    setDateRange(newDateRange);

    // Fetch new data if taskDetails is available
    if (taskDetails?.data && taskSharedUid) {
      setLoading(true);
      try {
        const websiteUid = taskDetails?.website_shared_uid;
        const adgroupId = taskDetails.data['query_output:adgroup_id']?.value;
        
        if (websiteUid && adgroupId) {
          await Promise.allSettled([
            BusinessInsightsEndPointLogic.getKeywordsPerformance(
              oauthTokenHeader,
              KeywordPerformanceQuery,
              websiteUid,
              adgroupId,
              newDateRange.startDate,
              newDateRange.endDate,
              "site"
            ),
            BusinessInsightsEndPointLogic.getNewSearchTerms(
              oauthTokenHeader,
              NewSearchTermsQuery,
              websiteUid,
              adgroupId,
              newDateRange.startDate,
              newDateRange.endDate,
              "site"
            ),
            BusinessInsightsEndPointLogic.getImpressionShare1(
              oauthTokenHeader,
              ImpressionShareQuery1,
              websiteUid,
              adgroupId,
              newDateRange.startDate,
              newDateRange.endDate,
              "site"
            ),
            BusinessInsightsEndPointLogic.getImpressionShare2(
              oauthTokenHeader,
              ImpressionShareQuery2,
              websiteUid,
              adgroupId,
              newDateRange.startDate,
              newDateRange.endDate,
              "site"
            ),
            BusinessInsightsEndPointLogic.getDailyAverage(
              oauthTokenHeader,
              DailyAverageQuery,
              websiteUid,
              adgroupId,
              newDateRange.startDate,
              newDateRange.endDate,
              "site"
            ),
          ]);
        }
      } catch (error) {
        store.dispatch(
          setDisplayErrorSnackBar({
            message: "Error updating keyword performance data",
            type: "error",
          })
        );
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      {loading || Object.keys(taskDetails).length <= 0 ? (
        <SimpleBackdrop />
      ) : (
        <>
          <InsightCards />
          <InsightKeyWordPerformance
            tableHeadings={tableHeadings}
            kewordPerformance={kewordPerformance}
            getDefaultDates={getDefaultDates}
            handleTimeframeChange={handleTimeframeChange}
            selectedTimeframe={selectedTimeframe}
            dateRange={dateRange}
          />
          <ImpressionShare
            impressionShare1={impressionShare1}
            impressionShare2={impressionShare2}
          />
          <DailyaverageImpressionShare dailyAverage={dailyAverage} />
          <NewSearchTerms
            tableHeadings={NewSearchTemrsTableHeading}
            newSearchTerms={newSearchTerms}
          />
          <AdditionalChanges />
          {/* <CommentsandFiles /> */}

          {/* Generic Discussion Module for Comments and Files */}
          <CommentsAndFiles
            objectType="tasks"
            referenceModule="Paid Traffic Insights"
            moduleType="businessInsights"
            objectSharedUid={taskSharedUid}
            postCommentTrackID="307"
            reactionTrackID="457"
            uploadFileTrackID="458"
            downloadFileTrackID="459"
            previewFileTrackID="517"
          />

          {/* fab button */}
          <Stack
            spacing={2}
            sx={{
              position: "fixed",
              bottom: 16,
              right: 16,
              zIndex: 1300,
              alignItems: "flex-end",
            }}
          >
            {/* Action Buttons with Zoom transition */}
            <Zoom in={open}>
              <Box
                sx={{
                  position: "fixed",
                  bottom: 72,
                  right: 16,
                  zIndex: 1300,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  gap: 2,
                }}
              >
                <Fab
                  variant="extended"
                  size="small"
                  onClick={ResolvePopupOpen}
                  sx={{
                    width: 112,
                    backgroundColor: "#7B1FA2",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#7B1FA2" },
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%"
                    data-tracker="318"
                  >
                    <Typography
                      fontSize={12}
                      fontWeight={500}
                      data-tracker="318"
                    >
                      RESOLVE
                    </Typography>
                    <CheckCircleOutlineOutlinedIcon />
                  </Stack>
                </Fab>
                <Fab
                  variant="extended"
                  size="small"
                  color="secondary"
                  onClick={AssignPopupOpen}
                  sx={{
                    width: 112,
                    backgroundColor: "#7B1FA2",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#7B1FA2" },
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%"
                    data-tracker="320"
                  >
                    <Typography
                      fontSize={12}
                      fontWeight={500}
                      data-tracker="320"
                    >
                      ASSIGN
                    </Typography>
                    <SwitchAccountOutlinedIcon />
                  </Stack>
                </Fab>
                <Fab
                  variant="extended"
                  size="small"
                  color="secondary"
                  onClick={ChangeStatusPopupOpen}
                  sx={{
                    width: 112,
                    backgroundColor: "#7B1FA2",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#7B1FA2" },
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%"
                    data-tracker="322"
                  >
                    <Typography
                      fontSize={12}
                      fontWeight={500}
                      data-tracker="322"
                    >
                      STATUS
                    </Typography>
                    <PendingOutlinedIcon />
                  </Stack>
                </Fab>
                <Fab
                  variant="extended"
                  size="small"
                  color="secondary"
                  onClick={MorePopupOpen}
                  sx={{
                    width: 112,
                    backgroundColor: "#7B1FA2",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#7B1FA2" },
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%"
                    data-tracker="324"
                  >
                    <Typography
                      fontSize={12}
                      fontWeight={500}
                      data-tracker="324"
                    >
                      MORE
                    </Typography>
                    <MoreVertOutlinedIcon />
                  </Stack>
                </Fab>
              </Box>
            </Zoom>
            {/* Main Toggle FAB */}
            <Fab
              variant="extended"
              color="secondary"
              size="small"
              onClick={handleToggle}
              sx={{
                width: 163,
                backgroundColor: "#7B1FA2",
                color: "#fff",
                "&:hover": { backgroundColor: "#7B1FA2" },
                padding: "20px 16px",
                borderRadius: "100px",
              }}
              data-tracker={open ? "312" : "317"}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                width="100%"
              >
                <Typography
                  fontSize={15}
                  fontWeight={500}
                  data-tracker={open ? "312" : "317"}
                >
                  {open ? "Close" : "Take Action"}
                </Typography>
                {open ? <CloseOutlinedIcon /> : <AutoFixHighOutlinedIcon />}
              </Stack>
            </Fab>
          </Stack>
          <ResolveInsightPopup
            open={openResolvePopup}
            onClose={ResolvePopupClose}
          />
          <AssignAdgroupPopup
            open={openAssignPopup}
            onClose={AssignPopupClose}
          />
          <ChangeStatusPopup
            open={openStatusPopup}
            onClose={ChangeStatusPopupClose}
          />
          <MoreAdgroupPopup
            open={openMorePopup}
            onClose={MorePopupClose}
            selectedSiteFloatingAction={websiteSharedUid}
            selectedDimensionsFloatingAction={""}
          />
        </>
      )}
    </>
  );
};

export default InsightAdGroup;
